Genesys('registerPlugin', 'SupportCenterHelper', (supportCenterHelperPlugin) => {
  supportCenterHelperPlugin.registerCommand('configure', (e) => {
    const config = e.data || {};
    const deploymentConfig = config.deploymentConfig || {};
    const supportCenterConfig = deploymentConfig.supportCenter;
    const targetElementSelector = supportCenterConfig.targetElementSelector || '#genesys-support-center';

    function loadSupportCenterJs() {
      Genesys('loadPlugin', 'SupportCenter', config);
    }

    function loadSupportCenterCss() {
      const cssElement = document.createElement('link');
      const baseUri = supportCenterHelperPlugin.data('ServiceDiscovery.uris.staticAssets');

      // This is the URL of SupportCenterPlugin CSS file. Any security scan issues are false positive.
      cssElement.href = `${baseUri}/support-center/support-center-plugins/main.css`; // eslint-disable-line
      cssElement.rel = 'stylesheet';

      document.head.appendChild(cssElement);
    }

    function loadSupportCenterFiles() {
      loadSupportCenterJs();
      loadSupportCenterCss();
    }

    function initializeSupportCenter() {
      if (document.querySelector(targetElementSelector)) {
        loadSupportCenterFiles();
      }
    }

    if ('loading' === document.readyState) {
      document.addEventListener('DOMContentLoaded', initializeSupportCenter); // eslint-disable-line
    } else {
      initializeSupportCenter();
    }

    e.resolve();
  });

  supportCenterHelperPlugin.ready();
});
